/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CptCode } from './CptCode';

export type ChargeCache = {
    row_object: any;
    type?: ChargeCache.type;
    readonly cpt_code?: CptCode;
    modifier?: ChargeCache.modifier | null;
}

export namespace ChargeCache {

    export enum type {
        CPT_CODE = 'cpt_code',
    }

    export enum modifier {
        TC = 'TC',
        _26 = '26',
    }


}
